import HTTP from '@/api';
import router from '../../router';
import cloneDeep from 'lodash/cloneDeep';

export default (store) => {
  HTTP.interceptors.response.use(
    response => new Promise((resolve) => { resolve(response); }),
    (error) => {
      if (error.config && error.response) {
        const statusCode = error.response.status;

        // if the http error need to be displayed to the user, we display it
        // if this is an Unauthorized error, we try again with a refresh token
        if (error.config.handleHttpError !== false && statusCode !== 401 && statusCode !== 403) {
          let msg = 'HTTP_ERROR.NO_RESPONSE';
          if (error.response.data) {
            if (error.response.data.length > 0 && error.response.data[0].code) {
              msg = error.response.data[0].code;
            } else if (statusCode !== 500) {
              msg = '';
              Object.keys(error.response.data).forEach((x) => {
                msg += `HTTP_ERROR.${x.toUpperCase()}`;
              });
            }
          }
          store.commit('alerts/setAlert', {
            msg,
          });
        } else if (statusCode === 500) {
          store.commit('alerts/setAlert', {
            msg: 'HTTP_ERROR.NO_RESPONSE',
          });
        } else if (statusCode === 401 || statusCode === 403) {
          // Get Refresh Token
          const originalRequest = cloneDeep(error.config);
          if (!originalRequest.base_retry) {
            originalRequest.base_retry = true;
            return store.dispatch('user/refresh').then(() => {
              originalRequest.headers.Authorization = `Bearer ${store.state.user.token}`;
              return Promise.resolve(HTTP(originalRequest));
            });
          }

          // still not authorised, we go to login page
          store.commit('user/logout');
          router.push({ path: '/', query: { rurl: encodeURI(router.currentRoute.path) } });
        }
      }

      return Promise.reject(error);
    },
  );
};
